import { render, staticRenderFns } from "./EditarModalidadContratacion.vue?vue&type=template&id=4061dfed&"
import script from "./EditarModalidadContratacion.vue?vue&type=script&lang=js&"
export * from "./EditarModalidadContratacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports